import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import StudentAuth from "@/pages/StudentAuth";
import StaffAuth from "@/pages/StaffAuth";
import Student from "@/pages/Student";
import ChatSession from "@/pages/ChatSession";
import Supervisor from "@/pages/Supervisor";
import Admin from "@/pages/Admin";
import Verify from "@/pages/Verify";

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">Cargando...</div>;
  if (!user) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<StudentAuth />} />
            <Route path="/staff" element={<StaffAuth />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/alumno" element={<Protected roles={["alumno"]}><Student /></Protected>} />
            <Route path="/alumno/sesion/:id" element={<Protected roles={["alumno"]}><ChatSession /></Protected>} />
            <Route path="/supervisor" element={<Protected roles={["supervisor", "admin"]}><Supervisor /></Protected>} />
            <Route path="/admin" element={<Protected roles={["admin"]}><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
